/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of electronic signature to use
 * @export
 */
export const SignatureType = {
    Qualified: 'QUALIFIED',
    Advanced: 'ADVANCED'
} as const;
export type SignatureType = typeof SignatureType[keyof typeof SignatureType];


export function instanceOfSignatureType(value: any): boolean {
    for (const key in SignatureType) {
        if (Object.prototype.hasOwnProperty.call(SignatureType, key)) {
            if (SignatureType[key as keyof typeof SignatureType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SignatureTypeFromJSON(json: any): SignatureType {
    return SignatureTypeFromJSONTyped(json, false);
}

export function SignatureTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignatureType {
    return json as SignatureType;
}

export function SignatureTypeToJSON(value?: SignatureType | null): any {
    return value as any;
}

export function SignatureTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SignatureType {
    return value as SignatureType;
}

